export default __webpack_public_path__ + "static/media/tempuser.5a61c161.webp";